import React, { useEffect, useRef, useState } from "react";
import "../styles/Intro.css";
import AnimatedRobot from "./AnimatedRobot";
import Icon from "./Icons"; 
import { gsap } from "gsap";

const roles = ["Data Analyst", "Product Analyst", "Business Analyst"];

const Intro = () => {
  const roleRef = useRef(null);
  const [currentRoleIndex, setCurrentRoleIndex] = useState(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;

    // Animation for changing roles
    const roleChangeInterval = setInterval(() => {
      gsap.to(roleRef.current, { opacity: 0, duration: 0.5, onComplete: () => {
        setCurrentRoleIndex(prevIndex => (prevIndex + 1) % roles.length);
        gsap.fromTo(roleRef.current, { opacity: 0 }, { opacity: 1, duration: 0.5 });
      }});
    }, 3000); // Change role every 3 seconds (adjust as needed)

    return () => clearInterval(roleChangeInterval); // Cleanup interval on unmount
  }, []);

  return (
    <div className="intro-section">
      <div className="intro-content">
        <h1 className="typist-content">
          <span className="intro-title">Hi, I'm </span>
          <span className="intro-name">Geetha Sagar Bonthu.</span>
        </h1>
        
        <div className="intro-subtitle">
          A <span className="intro-subtitle-name" ref={roleRef}>{roles[currentRoleIndex]}</span>
        </div>
        
        <div className="intro-desc">
          I turn raw data into trusted metrics that help teams decide faster.
        </div>
        
        <div className="intro-buttons">
          <a href="#contact" className="outline-button btn-effect">Get In Touch <Icon name="Mail" className="button-icon" /></a>
        </div>
      </div>
      
      <div className="intro-animation">
        <AnimatedRobot />
      </div>
    </div>
  );
};

export default Intro;